const dictionary = {
  1: 'grid--one',
  2: 'grid--two',
  3: 'grid--three',
  4: 'grid--four',
  5: 'grid--five',
  6: 'grid--six'
};

const getDictionaryMatch = key => dictionary[key] || dictionary[1];

export default getDictionaryMatch;
